<template>
  <div class="wrapper d-flex flex-column min-vh-100 bg-body">
    <unauthorized-header />
    <main v-show="!pageLoadingStatus" class="d-flex align-items-center">
      <router-view />
    </main>
  </div>
</template>

<script>
import UnauthorizedHeader from "@/views/organisms/UnauthorizedHeader";

export default {
  name: 'CenterLayout',
  components: {
    UnauthorizedHeader,
  },
  computed: {
    pageLoadingStatus() {
      return this.$store.state.pageLoading;
    },
  },
}
</script>

<style scoped>
main {
  min-height: calc(100vh - 3.5rem);
}
</style>
